import { useSelector } from 'react-redux';
import validator from 'validator';

import SocialBlock from '~/components/organisms/editor/SocialBlock/SocialBlock';
import { useAppDispatch } from '~/hooks/useRedux';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { socialMediaSlice, updateSocialNetworksThunk } from '~/store/reducers/previewScreens/social-media';
import { getSocialMediaReducer } from '~/store/reducers/previewScreens/social-media/selectors';

const { actions } = socialMediaSlice;

export default function Content() {
  const dispatch = useAppDispatch();
  const { socialLinks, micrositeData, isDeleteSocialLoading } = useSelector(getSocialMediaReducer);

  const handleSocialLinks = (val, type, index) => {
    if (micrositeData) {
      const addingValue = {
        network: val[index]?.network.toUpperCase() || '',
        url: val[index]?.value,
        title: val[index]?.title,
        microsite: micrositeData?.id,
      };

      const areValValid = val.every((item) => validator.isURL(item.value));

      dispatch(actions.setSocialLinks(val));
      if (areValValid) {
        switch (type) {
          case 'add':
            return dispatch(
              updateSocialNetworksThunk({
                id: micrositeData?.id,
                body: addingValue,
                type: 'add',
              }),
            );
          case 'update':
            return dispatch(
              updateSocialNetworksThunk({
                id: micrositeData?.id,
                body: {
                  id: micrositeData?.socials[index]?.id,
                  data: addingValue,
                },
                type: 'update',
              }),
            );
          case 'delete':
            return dispatch(
              updateSocialNetworksThunk({
                id: micrositeData?.id,
                body: micrositeData?.socials[index]?.id,
                type: 'delete',
              }),
            );
          default:
            break;
        }
      } else {
        dispatch(actions.setSocialLinks(val));
      }
    }
  };

  return (
    <CreateQRContentBlockLayout type="content">
      <SocialBlock
        dispatchHandler={(val) => dispatch(actions.setSocialLinks(val))}
        socialLinks={socialLinks}
        setSocialLinks={handleSocialLinks}
        isDeleteDisabled={isDeleteSocialLoading}
      />
    </CreateQRContentBlockLayout>
  );
}
